/**
 * Medan WhatsApp dalam popup "Edit Subscription" (2026-10-03, keputusan user).
 *
 * Add customer kini menerima email SAHAJA (utils/flowHubungan.js) → customer itu tiada nombor
 * dan butang WhatsApp / Remind mati untuknya. Medan ini membolehkan admin menambah atau
 * membetulkan nombor KEMUDIAN.
 *
 * - Customer MANUAL: boleh diisi/diubah + Save (server: `kemasLangganan` patch `{ phone }` —
 *   akaun SESAAT dicari semula di sana). Tidak boleh dikosongkan kalau tiada email
 *   (server menolak: rekod mesti ada sekurang-kurangnya satu).
 * - Pembeli Billplz: baca sahaja — nombor datang dari borang bayaran.
 *
 * ⚠️ KEMBAR rupa + aliran: FlowCustomerEmailField.jsx (medan Email di bawahnya).
 */
import { useState } from 'react';
import { Btn } from '../design/ui';
import { kemasLangganan } from '../services/flowLanggananService';

export default function FlowCustomerPhoneField({ customer, onSaved, onWhatsApp }) {
    const asal = String(customer.phone || '').replace(/\D/g, '');
    const [nilai, setNilai] = useState(customer.phone || '');
    const [sedang, setSedang] = useState(false);
    const [ralat, setRalat] = useState('');
    const [disimpan, setDisimpan] = useState(asal);

    // Butang Open memakai nombor yang SUDAH disimpan (objek customer induk boleh basi sehingga senarai dimuat semula).
    const buka = () => onWhatsApp?.({ ...customer, phone: disimpan });

    if (!customer.manual) {
        return (
            <div>
                <p className="s-kv__lab">WhatsApp</p>
                <div className="s-kv__box s-num">
                    {disimpan || <span className="s-dim">—</span>}
                    {disimpan && (
                        <span style={{ marginLeft: 'auto' }}>
                            <Btn size="sm" variant="ghost" onClick={buka}>Open</Btn>
                        </span>
                    )}
                </div>
            </div>
        );
    }

    const bersih = nilai.replace(/\D/g, '');
    const berubah = bersih !== disimpan;

    const simpan = async () => {
        setRalat('');
        // Nombor yang DITAIP tetapi tidak sah ditolak — tidak dianggap "kosong" secara senyap.
        if (nilai.trim() && (bersih.length < 8 || bersih.length > 20)) { setRalat('Enter a valid WhatsApp number.'); return; }
        if (!bersih && !customer.email) { setRalat('This customer has no email — keep a WhatsApp number so they can still be matched.'); return; }
        setSedang(true);
        try {
            await kemasLangganan(customer, { phone: bersih });
            setDisimpan(bersih);
            setNilai(bersih);
            onSaved?.(bersih);
        } catch (e) {
            setRalat(e?.code === 'functions/not-found'
                ? 'Not saved — the server update is not deployed yet.'
                : `Not saved: ${e?.message || 'unknown error'}`);
        } finally {
            setSedang(false);
        }
    };

    return (
        <div>
            <p className="s-kv__lab">WhatsApp</p>
            <div style={{ display: 'flex', gap: 8 }}>
                <input className="s-inp s-num" inputMode="tel" placeholder="0123456789" maxLength={30}
                    style={{ flex: 1, minWidth: 0 }}
                    value={nilai} onChange={(e) => setNilai(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter' && berubah && !sedang) simpan(); }} />
                {/* Satu butang pada satu masa: Save bila ada perubahan, Open bila nombor tersimpan. */}
                {berubah
                    ? <Btn size="sm" onClick={simpan} disabled={sedang}>{sedang ? 'Saving…' : 'Save'}</Btn>
                    : disimpan && <Btn size="sm" variant="ghost" onClick={buka}>Open</Btn>}
            </div>
            {ralat
                ? <p style={{ color: 'var(--s-stop)', fontSize: 13, margin: '6px 0 0' }}>{ralat}</p>
                : !disimpan && <p className="s-kv__hint">No number yet — add one to use the WhatsApp reminder.</p>}
        </div>
    );
}
